<template>
  <i
    v-if="computedIconClassName"
    class="yl-iconfont"
    :class="computedIconClassName"
    :style="computedIconStyle"
    v-bind="$attrs"
    v-on="$listeners"
  ></i>
</template>

<script>
import { get } from "lodash";
import { getFileSuffix } from "@/common/file";
/**
 * 文件类型及其图标对应
 * key: icon名称
 * value: 文件后缀[]
 * */
const ICON_EXT_MAP = {
  cad: ["dxf"],
  zip: ["zip"],
  rar: ["rar"],
  gif: ["gif"],
  audio: ["m4a", "mp3", "wma"],
  video: ["mp4", "avi", "wmv", "rm", "ram", "flv"],
  html: ["html", "htm"],
  dwg: ["dwg"],
  pdf: ["pdf"],
  word: ["doc", "docx"],
  xlsx: ["xls", "xlsx"],
  ppt: ["ppt", "pptx"],
  cdr: ["cdr"],
  vsd: ["vsd"],
  pic: ["jpg", "jpeg", "png", "bmp"],
  rvt: ["rvt"],
};

// 把ICON_EXT_MAP转为key值是后缀，value是icon名的对象
const EXT_TO_ICON_NAME_MAP = {};
for (const iconName in ICON_EXT_MAP) {
  (ICON_EXT_MAP[iconName] || []).forEach((ext) => {
    let extName = "";
    let extColor = "";
    if (Array.isArray(ext)) {
      const [name, color] = ext;
      extName = name;
      extColor = color;
    } else {
      extName = ext;
    }
    EXT_TO_ICON_NAME_MAP[extName] = {
      name: iconName,
      color: extColor,
    };
  });
}

export default {
  props: {
    fileName: {
      type: String,
      default: "",
    },
  },
  computed: {
    computedFileSuffix() {
      return getFileSuffix(this.fileName);
    },
    computedIconTypeConfig() {
      return EXT_TO_ICON_NAME_MAP[this.computedFileSuffix];
    },
    computedIconClassName() {
      return `tr-color-icon-file-${get(
        this.computedIconTypeConfig,
        "name",
        "common"
      )}`;
    },
    computedIconStyle() {
      const iconColor = get(this.computedIconTypeConfig, "color", "");
      if (iconColor) {
        return { color: iconColor };
      }
      return {};
    },
  },
};
</script>
